/*
URL id conversion:
    title.replaceAll("?", "").replaceAll("’", "").replaceAll(" ", "_").toLowerCase();
*/
export const FAQ_HOW_TO_SEARCH =
  "//sites.google.com/lbl.gov/data-portal-help/home/faq#h.lvcsytvxa4sg";

// TODO:
export const FAQ_WHY_TO_FILTER =
  "why_is_it_important_to_filter_my_search_results";

export const FAQ_HOW_TO_FILTER =
  "//sites.google.com/lbl.gov/data-portal-help/home/faq#h.3u2ppku5hy01";
export const FAQ_RESTRICTED =
  "//sites.google.com/lbl.gov/data-portal-help/home/faq#h.wfjibfml8dfa";
export const FAQ_ARCHIVED =
  "//sites.google.com/lbl.gov/data-portal-help/home/faq#h.3zyin7r02sgi";
export const FAQ_DOWNLOAD_DAILY_LIMITS =
  "//sites.google.com/lbl.gov/data-portal-help/home/faq#h.49ki7m9ru1y4";
export const FAQ_CURL_DOWNLOAD =
  "//sites.google.com/lbl.gov/data-portal-help/home/faq#h.89vwmt7wwn6p";

// TODO: where used this?
export const FAQ_API_DOC =
  "//sites.google.com/lbl.gov/data-portal-help/home/faq#h.gh2djcefoy6q";
export const FAQ_JGI_DATA =
  "//sites.google.com/lbl.gov/data-portal-help/home/faq#h.cqz559wu3mp0";
export const FAQ_GLOBUS_AND_HOW =
  "//sites.google.com/lbl.gov/data-portal-help/home/faq#h.vugvmzd1v9qv";
export const FAQ_CERTAIN_RESULTS = "data-portal-help/home/faq#h.pu0hznvk1524";

export const FAQ_URL = "//sites.google.com/lbl.gov/data-portal-help/home/faq";

export default FAQ_URL;
